import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';
import { getSessionTimestamp } from './cache-version';

const browserWindow = window as any;
const browserWindowEnv = browserWindow['config'] || {};

for (const key in browserWindowEnv) {
  if (browserWindowEnv.hasOwnProperty(key)) {
    const value = browserWindowEnv[key];
    const valueLower = String(value).toLowerCase();

    if (typeof value === 'object' && value !== null) {
      (environment as any)[key] = { ...(environment as any)[key], ...value };
    } else if (valueLower === 'true') {
      (environment as any)[key] = true;
    } else if (valueLower === 'false') {
      (environment as any)[key] = false;
    } else {
      (environment as any)[key] = value;
    }
  }
}

(window as any).ngDevMode = !environment.production;

initFederation(
  '/assets/federation.manifest.json',
  environment.production ? { cacheTag: getSessionTimestamp() } : undefined,
)
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
